import { BaseParser } from './BaseParser';
import { IParseResult, ParseResult } from '../FormatterTypes';

class TEDParseDefault extends BaseParser {
  public static getInstance(): BaseParser {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: BaseParser;

  defaultParams() {
    return '';
  }

  parse(text: string, params: string): IParseResult {
    return { value: text, result: ParseResult.OK };
  }
}

export { TEDParseDefault };
